/**
 * Static configuration for MSAL using environment variables
 * This is the fallback configuration when dynamic config fails
 */

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
        postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || window.location.origin
    },
    cache: {
        cacheLocation: "localStorage", // Changed from sessionStorage to localStorage for persistent auth
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                
                switch (level) {
                    case 'Error':
                        console.error(message);
                        return;
                    case 'Info':
                        console.info(message);
                        return;
                    case 'Verbose':
                        console.debug(message);
                        return;
                    case 'Warning':
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Scopes for login requests
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Scopes for Microsoft Graph file operations (Office preview)
 * Request these scopes when user wants to preview Office documents
 */
export const filePreviewRequest = {
    scopes: [
        "User.Read",
        "Files.ReadWrite",
        "Files.ReadWrite.All"
    ]
};

/**
 * Scopes for API requests to the backend
 * Uses environment variable for the API scope
 */
export const apiRequest = {
    scopes: [process.env.REACT_APP_API_SCOPE || "api://a3889d33-ade4-48fa-839e-1b0fde939a33/access_as_user"]
};

/**
 * Microsoft Graph configuration
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

/**
 * Backend API configuration
 */
export const backendConfig = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL
};
